// wijmo
import * as wjcCore from "@grapecity/wijmo"
// other
import qs from "qs"
import * as H from "history"
import { TWijmoComboBox } from "../../type/wijmoComponents"
import dayjs from "dayjs"

/**
 * URLに検索条件を反映
 * @param history
 * @param location
 * @param searchCondition
 */
export const pushQuery = (
  history: H.History<unknown>,
  location: H.Location<H.LocationState>,
  searchCondition: { [propertyName: string]: any }
) => {
  // JSON.stringifyを用いると日付がutcに変換され、queryの見た目がずれるので使用しない
  const hasValueObject: any = {}
  Object.keys(searchCondition).forEach((key) => {
    const searchValue = searchCondition[key]
    if (searchValue == null || searchValue === "") return
    hasValueObject[key] = searchValue
  })

  // 検索条件復元対応用にdayjsでtimezoneを残したisoに変換させる
  const queryValue = qs.stringify(
    {
      ...hasValueObject,
      searched: 1,
    },
    {
      serializeDate: (d: Date) => dayjs(d).format("YYYY-MM-DDTHH:mm:ssZ"),
    }
  )

  history.replace(`${location.pathname}?${queryValue}`)
}

export const clearQuery = (
  history: H.History<unknown>,
  location: H.Location<H.LocationState>
) => {
  history.replace(`${location.pathname}`)
}

/**
 * デフォルトComboBoxItemsSourceChangedHandler
 * @param setAction ItemsSource変更完了フラグセット用アクション
 * @returns ComboBox用ハンドラーメソッド
 */
export const createDefaultComboBoxItemsSourceChangedHandler = <TValue, TItem>(
  setAction: (
    value: React.SetStateAction<TWijmoComboBox<TValue, TItem> | null>
  ) => void
) => {
  return (control: TWijmoComboBox<TValue, TItem>, e: wjcCore.EventArgs) => {
    // 0件以上でのItemSourceに変更後のイベントを補足
    if (control.itemsSource.length !== 0) {
      setAction(control)
    }
  }
}

const pageHelper = {
  pushQuery,
  clearQuery,
  createDefaultComboBoxItemsSourceChangedHandler,
}

export default pageHelper
